/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  ApiGenderAndSterilization,
  ApiGenderAndSterilizationFromJSON,
  ApiGenderAndSterilizationFromJSONTyped,
  ApiGenderAndSterilizationToJSON,
} from './ApiGenderAndSterilization';

/**
 * @type ApiPetFormFieldsValuesInner
 *
 * @export
 */
export type ApiPetFormFieldsValuesInner = {
  type: 'GenderAndSterilization';
} & ApiGenderAndSterilization;

export function ApiPetFormFieldsValuesInnerFromJSON(json: any): ApiPetFormFieldsValuesInner {
  return ApiPetFormFieldsValuesInnerFromJSONTyped(json, false);
}

export function ApiPetFormFieldsValuesInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiPetFormFieldsValuesInner {
  if (json === undefined || json === null) {
    return json;
  }
  switch (json['type']) {
    case 'GenderAndSterilization':
      return {
        ...ApiGenderAndSterilizationFromJSONTyped(json, true),
        type: 'GenderAndSterilization',
      };
    default:
      throw new Error(
        `No variant of ApiPetFormFieldsValuesInner exists with 'type=${json['type']}'`,
      );
  }
}

export function ApiPetFormFieldsValuesInnerToJSON(value?: ApiPetFormFieldsValuesInner | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  switch (value['type']) {
    case 'GenderAndSterilization':
      return ApiGenderAndSterilizationToJSON(value);
    default:
      throw new Error(
        `No variant of ApiPetFormFieldsValuesInner exists with 'type=${value['type']}'`,
      );
  }
}
